import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-response',
    templateUrl: './response.component.html',
    styleUrls: ['./response.component.scss'],
    standalone: false
})
export class ResponseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
